import axios from "axios";

const API_URL = "https://phone360.net/api/";

class MainService {
  async list(model, data = "") {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    let url = API_URL + model;

    if (data) {
      url = API_URL + model + "?start=" + data.start + "&limit=" + data.limit;
    }
    const response = await axios.get(url, data);
    return response.data; // Geri dönen veriyi döndür
  }

  async delete(id, model) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.delete(API_URL + model + "/" + id);
    return response.data;
  }

  async get(model,id) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.get(API_URL + model + "?id=" + id);
    return response.data;
  }

  async add(data, model) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.post(API_URL + model, data);
    return response.data;
  }

  async search(key, model) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.get(API_URL + model + "/search?key=" + key);
    return response.data; // Geri dönen veriyi döndür
  }

 
  async fetchRates() {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.get("https://phone360.net/api/fetchRates");
    return response.data;
  }
}

export default new MainService();
